import { render } from "./MikeArmitage.vue?vue&type=template&id=071444e9&ts=true"
import script from "./MikeArmitage.vue?vue&type=script&lang=ts"
export * from "./MikeArmitage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__